import './StoreBadges.css';

const APPLE_ICON = (
  <svg className="store-badge__icon" width="22" height="22" viewBox="0 0 22 22" fill="none">
    <path
      d="M15.5 11.6c0-1.7 1.4-2.5 1.5-2.6-0.8-1.2-2.1-1.4-2.5-1.4-1.1-0.1-2.1 0.6-2.6 0.6-0.5 0-1.4-0.6-2.3-0.6-1.2 0-2.3 0.7-2.9 1.8-1.2 2.2-0.3 5.4 0.9 7.2 0.6 0.9 1.3 1.8 2.2 1.8 0.9 0 1.2-0.6 2.3-0.6 1.1 0 1.4 0.6 2.3 0.5 1 0 1.6-0.9 2.2-1.8 0.7-1 1-2 1-2.1-0.1 0-2.1-0.8-2.1-3.2zM13.7 6.4c0.5-0.6 0.8-1.4 0.7-2.2-0.7 0-1.5 0.4-2 1-0.4 0.5-0.8 1.4-0.7 2.1 0.8 0.1 1.5-0.4 2-0.9z"
      fill="white"
    />
  </svg>
);

const GOOGLE_ICON = (
  <svg className="store-badge__icon" width="22" height="24" viewBox="0 0 22 24" fill="none">
    <path d="M0.92 1.18 L11.92 12 L0.92 22.82 Z" fill="#00D4FF" />
    <path d="M11.92 8.33 L20.79 12 L11.92 15.67 Z" fill="#FFCC00" />
    <path d="M1.38 11.91 L15.68 12 L1.38 22.72 Z" fill="#FF4444" />
    <path d="M1.38 0.42 L15.68 11.9 L1.38 11.9 Z" fill="#00C853" />
  </svg>
);

function Badge({ url, modifier, ariaLabel, icon, smallText, bigText }) {
  const className = `store-badge store-badge--${modifier}${url ? '' : ' store-badge--disabled'}`;
  const content = (
    <>
      {icon}
      <span className="store-badge__text">
        <span className="store-badge__small">{smallText}</span>
        <span className="store-badge__big">{bigText}</span>
      </span>
    </>
  );
  if (url) {
    return (
      <a className={className} href={url} target="_blank" rel="noopener noreferrer" aria-label={ariaLabel}>
        {content}
      </a>
    );
  }
  return (
    <span className={className} aria-label={ariaLabel}>
      {content}
    </span>
  );
}

export default function StoreBadges({ appStoreUrl, googlePlayUrl }) {
  return (
    <div className="store-badges">
      {appStoreUrl !== undefined && (
        <Badge
          url={appStoreUrl}
          modifier="apple"
          ariaLabel="Descargar en App Store"
          icon={APPLE_ICON}
          smallText="Download on the"
          bigText="App Store"
        />
      )}
      {googlePlayUrl !== undefined && (
        <Badge
          url={googlePlayUrl}
          modifier="google"
          ariaLabel="Disponible en Google Play"
          icon={GOOGLE_ICON}
          smallText="DISPONIBLE EN"
          bigText="Google Play"
        />
      )}
    </div>
  );
}
